import { SchoolContext } from "context/SchoolContext";
import { useContext } from "react";

export function useSchoolContext() {
    const context = useContext(SchoolContext);

    if (context === undefined) {
        throw new Error('useSchoolContext must be used within a SchoolProvider');
    }

    return context;
}

export default useSchoolContext;